'use client';

import MAIALogoDark from '../_assets/maia-logo-dark.svg';
import MAIALogoLight from '../_assets/maia-logo-light.svg';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { Badge } from './ui/badge';

export default function Logo() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const currentTheme = mounted ? resolvedTheme : 'light';
  const logoSrc = currentTheme === 'dark' ? MAIALogoLight : MAIALogoDark;

  return (
    <div className="flex justify-center items-center gap-2">
      <Image
        src={logoSrc}
        alt="MAIA Logo"
        width={80}
        height={34}
        className="transition-opacity duration-200"
        priority
      />
      <Badge className="h-7 bg-primary text-background">Router</Badge>
    </div>
  );
}
